/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function CanvasPrint() {
  const [PriceList, setpriceList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getpriceList();
  }, [search_key, currentPage]);

  const getpriceList = () => {
    setLoading(true);
    GetService(`${API_URL.GET_CANVAS_LIST}?searchkey=${search_key}`).then((res) => {
      if (res?.data?.status === true) {
        setpriceList(res.data.data);
        // SetTotalPageCount(res.data.totalPages);
        // SetTotalCount(res.data.totalItems);
        // setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [customsize, setcustomSize] = useState("");
  const [thinGallery, setthinGallery] = useState();
  const [thickGallery, setthickGallery] = useState("");
  const [framed, setframed] = useState("");
  const [rolled, setrolled] = useState();
  const [status, setstatus] = useState("");
  const [discount_price, setdiscount_price] = useState("");

  useEffect(() => {
    console.log(selectedData);
    setcustomSize(selectedData?.size);
    setthinGallery(selectedData?.thinGallery);
    setthickGallery(selectedData?.thickGallery);
    setframed(selectedData?.framed);
    setrolled(selectedData?.rolled);
    setstatus(selectedData?.status);
    setdiscount_price(selectedData?.discount_price);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!customsize || !thinGallery || !thickGallery || !framed || !rolled) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    let formdata = {
      id: selectedData?.id,
      discount_price,
      rolled,
      framed,
      thickGallery,
      thinGallery,
    };

    PostService(API_URL.UPDATE_PRICE_LIST, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getpriceList);
          resetFunc();
          // getContentList();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changestatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "1" ? "0" : "1",
    };

    PostService(API_URL.UPDATE_PRICE_LIST, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(`Status ${status === "1" ? "inactive" : "active"} successfully`, getpriceList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() {
    setcustomSize();
    setthinGallery();
    setthickGallery();
    setframed();
    setrolled();
    setstatus();
    setdiscount_price();
    setError(false);
    setsubmitLoader(false);
  }

  function downloadcsv() {
    const data = PriceList.map((item, i) => ({
      size: item?.size,
      id: item?.id,
      thinGallery: item?.thinGallery,
      thickGallery: item?.thickGallery,
      rolled: item?.rolled,
      framed: item?.framed,
      discount_price: item?.discount_price,
    }));
    exportToCSV(data, "CanvasSize.csv");
  }

  function exportToCSV(data, filename) {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    link.click();
  }

  function convertToCSV(data) {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((obj) => Object.values(obj).join(","));

    return `${header}\n${rows.join("\n")}`;
  }

  const [Adderror, setAddError] = useState(false);

  function resetAddModal() {
    setAddError(false);
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">Single Canvas List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Single Canvas List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center d-flex justify-content-between">
                    <div className="col-md-4 p-0">
                      <div className="offset-md-1">
                        <button
                          type="submit"
                          className="btn btn-primary py-2"
                          data-toggle="modal"
                          data-target="#AddModal"
                          onClick={() => {
                            downloadcsv();
                          }}
                        >
                          Export Csv
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive mt-4">
                    {!loading && (
                      <table className="table table-hover table-striped text-nowrap table-bordered">
                        <thead>
                          <tr className="pricelistrow">
                            <th className="text-center">S.No</th>
                            <th className="text-center">Canvas Size</th>
                            <th className="text-center">
                              Thin Gallery Wrap($)
                            </th>
                            <th className="text-center">
                              Thick Gallery Wrap($)
                            </th>
                            <th className="text-center">Framed($) </th>
                            <th className="text-center">Rolled in a Tube($)</th>
                            <th className="text-center">Discount Price</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {PriceList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>{data?.size ? data?.size : "N/A"}</td>
                              <td>
                                {data?.thinGallery ? data?.thinGallery : "N/A"}
                              </td>
                              <td>
                                {data?.thickGallery
                                  ? data?.thickGallery
                                  : "N/A"}
                              </td>
                              <td>{data?.framed ? data?.framed : "N/A"}</td>
                              <td>{data?.rolled ? data?.rolled : "N/A"}</td>
                              <td>
                                {data?.discount_price
                                  ? data?.discount_price
                                  : "N/A"}
                              </td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "1"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status === "1" ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={data?.status === "1"}
                                    onChange={() => {
                                      changestatus(data?.id, data.status);
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>

                                {/* <Link
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  to={`view/${data?._id}`}
                                >
                                  <i className="text-warning fas fa-eye"></i>
                                </Link> */}
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                                {/* <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(data?.mobilesizeid, "Price");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span> */}
                              </td>
                            </tr>
                          ))}
                          {PriceList && PriceList.length === 0 && (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- Edit Modal Start------------------ */}
      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit Single Canvas
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Canvas Size</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={customsize}
                        onChange={(e) => setcustomSize(e?.target?.value)}
                        placeholder="customSize"
                        readOnly
                      />
                      {error && !customsize && (
                        <div className="error mt-1">customSize is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Thin Gallery Wrap($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="thin Gallery Wrap"
                        value={thinGallery}
                        onChange={(e) => setthinGallery(e?.target?.value)}
                      />
                      {error && !thinGallery && (
                        <div className="error mt-1">
                          thin Gallery Wrap is required
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Thick Gallery Wrap($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="thick Gallery Wrap"
                        value={thickGallery}
                        onChange={(e) => setthickGallery(e?.target?.value)}
                      />
                      {error && !thickGallery && (
                        <div className="error mt-1">
                          thick Gallery Wrap is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Framed($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="framed"
                        value={framed}
                        onChange={(e) => setframed(e?.target?.value)}
                      />
                      {error && !framed && (
                        <div className="error mt-1">frame is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>rolled in the Tude($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="rolled in the Tude"
                        value={rolled}
                        onChange={(e) => setrolled(e?.target?.value)}
                      />
                      {error && !rolled && (
                        <div className="error mt-1">
                          rolled in the Tude is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Discount Price</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Discount Price"
                        value={discount_price}
                        onChange={(e) => setdiscount_price(e?.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* ---------------- Edit Modal End------------------ */}
    </div>
  );
}
